import {
  purchaseBillingRank,
  purchasePlanRank,
  type PurchasePackage,
} from "~/services/purchases";
export function purchasePackageLabel(pkg: {
  billingPeriod: "monthly" | "annual" | "other";
  plan: "pro" | "unknown";
  priceText: string;
  title: string;
}) {
  const plan = pkg.plan === "pro" ? "MintStint Pro" : pkg.title;
  if (pkg.billingPeriod === "monthly") {
    return `${plan} monthly — ${pkg.priceText}`;
  }
  if (pkg.billingPeriod === "annual") {
    return `${plan} annual — ${pkg.priceText}`;
  }
  return `${pkg.title} — ${pkg.priceText}`;
}

export function signupPlanLabel(_plan: "pro") {
  return "MintStint";
}

export function checkoutSortValue(
  pkg: PurchasePackage,
  checkoutIntent: { plan: "pro"; billing: "monthly" },
) {
  const planRank =
    pkg.plan === checkoutIntent.plan ? 0 : purchasePlanRank(pkg.plan) + 1;
  const billingRank =
    pkg.billingPeriod === checkoutIntent.billing
      ? 0
      : purchaseBillingRank(pkg.billingPeriod) + 1;
  return planRank * 10 + billingRank;
}

export function decodeQrCodeSvg(value: string | undefined) {
  if (!value) return null;
  const prefix = "data:image/svg+xml;utf-8,";
  const svg = value.startsWith(prefix) ? value.slice(prefix.length) : value;
  try {
    return decodeURIComponent(svg);
  } catch {
    return svg;
  }
}
